import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ beim Laden prüfen ob Cookie gültig
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch("https://lborrito.de/api/auth/me", {
          credentials: "include",
        });
        if (res.ok) {
          const data = await res.json();
          setUser({ username: data.username });
        } else {
          setUser(null);
        }
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  const login = async (username, password) => {
    const res = await fetch("https://lborrito.de/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // 🔑 Cookie setzen
      body: JSON.stringify({ username, password }),
    });

    if (res.ok) {
      const me = await fetch("https://lborrito.de/api/auth/me", {
        credentials: "include",
      });
      if (me.ok) {
        const data = await me.json();
        setUser({ username: data.username });
      }
    } else {
      throw new Error("Login fehlgeschlagen");
    }
  };

  const logout = async () => {
    await fetch("https://lborrito.de/api/auth/logout", {
      method: "POST",
      credentials: "include",
    });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
